import React, { useState, useEffect } from "react";
import { Button, message } from "antd";
import { YHModal } from "@/components/YHModal";
import useGlobalModel from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
import { psiService } from "../GoodsRecordsModal/psiService";
import { orgService } from "@/views/base/org/orgService";
import { formatNum } from "@/utils/utils";
import Table, { ColumnsType } from "antd/lib/table";
import { useStockStatisticModel } from "../../stockStatisticModel";

//占用库存数
export const OccupyNumModal = () => {
	const { user: { shopId }, setLoadingInfo, userBranch } = useGlobalModel();
	const [dataSource, setDataSource] = useState<any[]>([]);
	const { stockQueryModal, setStockQueryModal } = useStockStatisticModel();
	const [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		stockQueryModal && loadData();
	}, [stockQueryModal])

	const onCancel = () => {
		setStockQueryModal(null);
	}

	const loadData = async () => {
		setLoading(true);
		try {
			const searchParams = {
				shopId,
				materialCode: stockQueryModal?.materialCode,
				types: ['occupy_ssrd', 'occupy_sprd', 'occupy_ssd', 'occupy_std'],
				pageNum: 1,
				pageSize: 1000,
			}
			if (userBranch === 'scm') {
				let { retData } = await psiService.scmPurchaseSaleStorageDeatil(searchParams);
				setDataSource(retData ?? []);
			}
			else if (userBranch === 'vrm') {
				const params = { ...searchParams, "types": ["occupy_vam", "occupy_vmm", "occupy_ssd", "occupy_prd"] }
				let { retData } = await psiService.vrmPurchaseSaleStorageDeatil(params);
				setDataSource(retData ?? []);
			}
			else if (userBranch === 'bcm') {
				let { retData } = await psiService.bcmPurchaseSaleStorageDeatil(searchParams);
				setDataSource(retData.records ?? []);
			}
			else if (userBranch === 'ci') {
				let { retData: org } = await orgService.getByShopId(shopId);
				const params = { ...searchParams, "organId": org.id, "types": ["occupy_ssd", "occupy_omm", "occupy_morm", "occupy_mom", "occupy_prd"] }
				let { retData } = await psiService.ciPurchaseSaleStorageDeatil(params);
				setDataSource(retData ?? []);
			}
			setLoading(false)
		}
		catch {
			setLoading(false);
			setDataSource([])
		}
	}

	//导出
	const exportDetail = async () => {
		if (!dataSource.length) {
			message.warning("无数据");
			return;
		}
		setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
		try {
			const searchParams = {
				shopId,
				materialCode: stockQueryModal?.materialCode,
			}
			let result = await psiService.purchaseSaleStorageDeatilExport(searchParams);
			result && setLoadingInfo({ loadingVisible: false, txt: "" });
			convertRes2Blob(result);
		} catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
	}

	const columns: ColumnsType<any> = [
		{
			title: '序号',
			width: 66,
			align: "center",
			render: (t: any, r: any, i: number) => i + 1
		}, {
			title: '业务日期',
			width: 180,
			align: "center",
			dataIndex: 'createTime',
		}, {
			title: '单据编号',
			width: 120,
			align: "center",
			dataIndex: 'code',
		}, {
			title: '单价',
			width: 160,
			align: "center",
			dataIndex: 'price',
			render: text => `￥${formatNum(text)}`
		}, {
			title: '占用数量',
			width: 140,
			align: "center",
			dataIndex: 'num',
		}, {
			title: '金额',
			width: 120,
			align: "center",
			render: (text, record) => `￥${formatNum(record.num * record.price)}`
		}
	];

	const action = <Button
		className="mr-5 font14"
		type="link"
		size="small"
		shape="round"
		onClick={() => exportDetail()}
	>导出</Button>

	return <YHModal
		visible={!!stockQueryModal}
		onCancel={onCancel}
		title={<p><span>占用数量:{["ci", "vrm", "bcm"].includes(userBranch) ? stockQueryModal?.inventoryOccupied : stockQueryModal?.occupyNum}</span><span className="ml-20">商品编号:{stockQueryModal?.materialCode}</span><span className="ml-20">商品名称:{stockQueryModal?.materialName}</span></p>}
		width={1300}
		bodyHeight={550}
	>
		<Table
			loading={loading}
			rowKey={record => record.id}
			columns={columns}
			dataSource={dataSource}
			pagination={false}
			scroll={{ x: 'max-content', y: 340 }}
		/>
	</YHModal>
}